import _ from 'underscore';

export const getDisclaimerMessageStyles = ({
  styleOverrides = {},
}) => () => {
  const overrides = _.pick(styleOverrides, [
    'disclaimerInfo',
    'disclaimerInfoInline',
  ]);

  return {
    disclaimerInfo: _.extend({
      fontSize: 12,
      lineHeight: '20px',
      textAlign: 'left',
      padding: '0 24px 20px 24px',
    }, overrides.disclaimerInfo),
    disclaimerInfoInline: _.extend({}, overrides.disclaimerInfoInline),
  };
};
